module.exports = __webpack_public_path__ + "img/dot.9d7e876c.svg";